import { FC } from 'react';
import { PhoenixImage } from '@phoenix/core/frontend/shared/ui/assets/phoenix-image';
import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';

export const CompatiblePlaceholderCard: FC<{ imageSrc: string }> = ({ imageSrc }) => {
  return (
    <div className="relative h-full overflow-hidden rounded-lg border border-secondary-mid" data-testid="compatible-placeholder-card">
      <PhoenixImage
        layout="fill"
        objectFit="cover"
        src={imageSrc}
        staticTags={['imagesDashboard']}
        sizes={`(max-width: ${containerQueries.tablet}) 100vw, (max-width: ${containerQueries.desktop}) 50vw, 30vw`}
      />
    </div>
  );
};
